import { Injectable, Output, EventEmitter, ElementRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ResponsiveService {
  @Output() toggleSidenavEvent = new EventEmitter<void>();
  @Output() toggleDrawerOpenCloseEvent = new EventEmitter<boolean>();
  @Output() toggleDrawerDisplayModeEvent = new EventEmitter<string>();
  @Output() containerResizeEvent = new EventEmitter<string>();
  private smallScreenWidth = 768;
  private largeBreakPoints = [Breakpoints.Large, Breakpoints.XLarge];

  private containerWidthChanged$ = new BehaviorSubject<string>('');
  private observer: ResizeObserver;

  constructor(private breakpointObserver: BreakpointObserver) {}

  getCustomObserver() {
    return this.breakpointObserver.observe([`(min-width: ${this.smallScreenWidth + 1}px)`]);
  }

  getLargeObserver() {
    return this.breakpointObserver.observe(this.largeBreakPoints);
  }

  toggleSidenav() {
    this.toggleSidenavEvent.emit();
  }

  toggleDrawerOpenClose(showDrawer) {
    this.toggleDrawerOpenCloseEvent.emit(showDrawer);
  }

  toggleDrawerDisplayMode(drawerMode) {
    this.toggleDrawerDisplayModeEvent.emit(drawerMode);
  }

  isSmallScreen(width = null) {
    const currentScreenWidth = width ? width : window.innerWidth;
    return currentScreenWidth <= this.smallScreenWidth;
  }

  isLargeScreen() {
    return this.breakpointObserver.isMatched(this.largeBreakPoints);
  }

  closeMenuOnSmallScreen() {
    if (this.isSmallScreen()) {
      this.toggleSidenav();
    }
  }

  setResizeObserver(elementToObserve: ElementRef<any>) {
    this.observer = new ResizeObserver((entries) => {
      let containerSize: string = 'fullsize';
      let containerWidth: number = entries[0].contentRect.width;

      if (containerWidth > 1000) {
        containerSize = 'fullsize';
      } else if (containerWidth <= 150) {
        containerSize = 'petitesize';
      } else if (containerWidth <= 450) {
        containerSize = 'xsmallsize';
      } else if (containerWidth <= 700) {
        containerSize = 'smallsize';
      } else {
        containerSize = 'midsize';
      }

      this.containerWidthChanged$.next(containerSize);
    });

    this.observer.observe(elementToObserve.nativeElement);
  }

  getResizeObserver(): BehaviorSubject<string> {
    return this.containerWidthChanged$;
  }

  destoryResizeObserver(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
